import React from "react";
import { HandleError, RadioGroup, TextField, NumberField } from "../form";
import FormRow from "../FormRow";
import { LAUNDRY, SECTION_8 } from "../../constants";

function FormUnit({ suffix }) {
  let defaultSuffix = "";
  if (suffix) {
    defaultSuffix = `${suffix}.`;
  }

  return (
    <>
      <FormRow label="Unit number">
        <TextField name={`${defaultSuffix}number`} />
      </FormRow>
      <FormRow label="Floor level">
        <NumberField name={`${defaultSuffix}floorLevel`} />
      </FormRow>
      <FormRow label="Laundry">
        <RadioGroup list={LAUNDRY} name={`${defaultSuffix}laundry`} />
        <HandleError name={`${defaultSuffix}laundry`} />
      </FormRow>
      <FormRow label="Number of bedrooms">
        <NumberField name={`${defaultSuffix}numberOfBedrooms`} />
      </FormRow>
      <FormRow label="Number of other rooms">
        <NumberField name={`${defaultSuffix}numberOfOtherRooms`} />
      </FormRow>
      <FormRow label="Number of parking spot">
        <NumberField name={`${defaultSuffix}numberOfParkingSpots`} />
      </FormRow>
      <FormRow label="Number of bathrooms">
        <NumberField name={`${defaultSuffix}numberOfBathrooms`} />
      </FormRow>
      <FormRow label="Section 8">
        <RadioGroup
          list={SECTION_8}
          name={`${defaultSuffix}section8Approved`}
        />
        <HandleError name={`${defaultSuffix}section8Approved`} />
      </FormRow>
    </>
  );
}

export default FormUnit;
